import './Modal.scss';
import usePressEsc from '../../hooks/usePressEsc';

const Modal = ({
  show,
  setShow,
  children,
  className,
  minWidth = true,
  onClose,
  showCloseButton = true,
  closeBtnClassname,
  relativeCloseButton,
  isFirstFilterModal = false,
  withoutOverFlow = false,
  defaultCursor = false,
  closeOnPressEsc = true,
}) => {
  const closeModal = () => {
    setShow(false);
    if (onClose) {
      onClose();
    }
  };

  usePressEsc(() => {
    if (show) {
      setShow(false);
    }
  }, closeOnPressEsc);

  return (
    <>
      {show ? (
        <>
          <div
            id="custom-modal"
            data-testid="custom-modal"
            className={`h-auto card ${withoutOverFlow ? '' : 'overflow'} modal-card ${className} ${
              minWidth && 'min-width'
            } ${defaultCursor && 'defaultCursor'}`}
          >
            {showCloseButton && (
              <button
                type="button"
                data-testid="close-button"
                className={`${
                  relativeCloseButton ? 'modal-close-button-relative' : 'modal-close-button'
                } ${closeBtnClassname}`}
                onClick={closeModal}
              >
                &times;
              </button>
            )}
            {children}
          </div>
          <div
            className="modal-background-custom"
            onClick={!isFirstFilterModal ? closeModal : undefined}
            aria-hidden="true"
          />
        </>
      ) : null}
    </>
  );
};

export default Modal;
